<template>
  <section class="evento-lux">
    <div class="stars-container">
      <div class="star" v-for="n in 50" :key="n" :style="generateStarStyle()"></div>
    </div>

    <article ref="card" class="card" aria-label="Celebración"><br>
      <h3 class="titulo-script">Celebración</h3>

  

      <img class="icono" src="@/assets/10.avif" alt="" />

      <p class="lugar">Floridian Ballrooms</p>
    <!-- ✅ NUEVA IMAGEN CIRCULAR -->
      <div class="imagen-circular-wrapper">
        <img
          class="imagen-circular"
          src="@/assets/c.png"
          alt="Lugar del evento"
        />
      </div>
      <p class="hora">7:00 PM</p>

      <p class="direccion">
        17850 NW 2nd Street <br>
        Pembroke Pines, Florida 33029
      </p>

      <a
        ref="btn"
        class="btn-rosa"
        href="https://maps.app.goo.gl/PnDHRPS2BKA2xo8J6"
        target="_blank"
        rel="noopener"
      >
        ¿Cómo llegar?
        <span class="sheen" aria-hidden="true"></span>
      </a>
    </article>
  </section>
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'EventoSectionLuxuryScroll',
  setup () {
    const card = ref(null)
    const btn = ref(null)

    const generateStarStyle = () => {
      const top = Math.random() * 100
      const left = Math.random() * 100
      const size = Math.random() * 2 + 1
      const duration = Math.random() * 3 + 2
      const delay = Math.random() * 5

      return {
        top: `${top}%`,
        left: `${left}%`,
        width: `${size}px`,
        height: `${size}px`,
        animationDuration: `${duration}s`,
        animationDelay: `${delay}s`
      }
    }

    const animCard = (cardEl, btnEl) => {
      const $ = gsap.utils.selector(cardEl)
      const icono = $('.icono')
      const titulo = $('.titulo-script')
      const imagenCircular = $('.imagen-circular-wrapper')
      const hora = $('.hora')
      const lugar = $('.lugar')
      const dir = $('.direccion')

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: cardEl,
          start: 'top 88%',
          end: 'bottom 65%',
          scrub: 0.25
        },
        defaults: { ease: 'power2.out' }
      })

      tl.from(cardEl, { opacity: 0, y: 22, duration: 0.38 })
        .from(titulo, { opacity: 0, y: 18, duration: 0.38 })
        
        /* ✅ NUEVA ANIMACIÓN BONITA PARA IMAGEN CIRCULAR */
        .from(imagenCircular, { 
          opacity: 0, 
          scale: 0.6, 
          y: 20, 
          duration: 0.6, 
          ease: 'back.out(1.7)' 
        }, '-=0.2')

        .from(icono, { opacity: 0, y: 16, duration: 0.35 }, '-=0.2')
        .from(hora, { opacity: 0, x: -22, duration: 0.35 }, '-=0.2')
        .from(lugar, { opacity: 0, x: 22, duration: 0.35 }, '-=0.2')
        .from(dir, { opacity: 0, y: 14, duration: 0.34 }, '-=0.12')
        .from(btnEl, { opacity: 0, y: 12, scale: 0.97, duration: 0.34 }, '-=0.1')
    }

    onMounted(() => {
      animCard(card.value, btn.value)
    })

    return { card, btn, generateStarStyle }
  }
}
</script>

<style scoped>

/* 🔥 NUEVA IMAGEN CIRCULAR */
.imagen-circular-wrapper {
  width: 210px;
  height: 210px;
  margin: 0 auto 16px;
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0,0,0,0.25);
  border: 4px solid rgba(255,255,255,0.6);
}

.imagen-circular {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* TODO LO DEMÁS SE QUEDA EXACTAMENTE IGUAL */
/* No se modifica nada más */

</style>

<style scoped>
/* ==================== BASE ELEGANTE ==================== */
:root {
  --rosa: #f4c6cc;
  --rosa-alt: #f0c3e3;
  --tinta: #141414;
  --gris: #5a5858;
  --borde: #e8e4e4;
}

.evento-lux {
  position: relative; /* Para las estrellas */
  min-height: 100%;
  padding: 0px 18px 64px;
  overflow: hidden; /* Evita scroll por las estrellas */
  background-image: 
    linear-gradient(to bottom, rgba(0, 0, 0, 0.516) 60%, rgba(26, 29, 81, 0.7) 85%, rgba(31, 33, 61, 0.642) 100%),
    url('@/assets/fondi.png');
  background-size: cover;
  background-size: cover;

  background-size: cover;
  background-position: center center; 
  background-repeat: no-repeat;

  color: #ffffff;
  display: grid;
  gap: 22px;
  place-items: center;
}

/* ==================== SISTEMA DE ESTRELLAS ==================== */
.stars-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}

.star {
  position: absolute;
  background: white;
  border-radius: 50%;
  opacity: 0.3;
  box-shadow: 0 0 8px white;
  animation: twinkle linear infinite;
}

@keyframes twinkle {
  0% { opacity: 0.1; transform: scale(1); }
  50% { opacity: 0.8; transform: scale(1.2); }
  100% { opacity: 0.1; transform: scale(1); }
}

/* ==================== TARJETA ==================== */
.card {
  position: relative;
  z-index: 1; /* Por encima de las estrellas */
  width: min(440px, 92vw);
  border: 1px solid var(--borde);
  border-radius: 18px;
  padding: 24px 20px 8px;
  text-align: center;
  margin-top:100px;
  background:#e4cdc200;
}

/* Icono discreto */
.icono {
  width: 52px;
  height: auto;
  display: block;
  margin: 0 auto 10px;
  filter: brightness(0) invert(1)
          drop-shadow(0 1px 0 rgba(0, 0, 0, 0.05));
  opacity: 0.92;
}

.imagen-salon-wrapper {
  margin: 8px auto 14px;
  overflow: hidden;
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.18);
  border: 10px double #f1a6c8;
  border-radius: 20px;
}

.imagen-salon {
  display: block;
  width: 100%;
  height: auto;
  transform-origin: center;
}

/* Tipos */
.titulo-script {
  font-family: 'britishgruesa', cursive;
  font-weight: 400;
  font-size: 80px !important;
  color:#d8af71;
  letter-spacing: 0.4px;
  margin: 4px 0 8px;
}
.hora {
  font-family: 'fa', sans-serif;
  font-size: 24px;
  color: #ffff;
  margin: 0 0 6px;
}
.lugar {
  font-family: 'cursivatitulo', serif;
  font-size: 28px !important;
  color: #f8f8f3;
  font-weight: 500;
  margin: 0 4px 66px; /* Ajustado según tu código original */
  margin: 0 4px 6px;
  letter-spacing: 0.0;
}
.direccion {
  font-family: 'padres', serif;
  font-style: italic;
  color: #ebece0;
  font-size: 17px;
  line-height: 1.5;
  margin: 0 auto 10px;
  max-width: 90%;
}

.nota-lugar {
  font-family: 'padres', serif;
  font-size: 16px;
  color: #eeefe7;
  padding: 8px 10px;
  margin: 4px 0 16px;
  max-width: 100%;
  border-radius: 10px;
}

/* ==================== BOTÓN ROSA ==================== */
.btn-rosa {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 11px 20px;
  border-radius: 14px;
  background: linear-gradient(
    180deg,
    #ffffff 0%,
    #f3f3f3 100%
  );
  color: #1f1f1f;
  text-decoration: none;
  font-family: 'padres', sans-serif;
  font-weight: 800;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  box-shadow:
    0 6px 16px rgba(0, 0, 0, 0.12),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);
  transition:
    transform 0.18s cubic-bezier(.4,0,.2,1),
    box-shadow 0.18s cubic-bezier(.4,0,.2,1),
    filter 0.18s ease;
  z-index: 0;
}

/* ==================== LÍNEA VERTICAL ==================== */
.linea-wrapper {
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin-top: 12px;
}
.linea {
  width: 1px;
  height: 64px;
  background: linear-gradient(to bottom, #171717, #2a2929);
  transform: scaleY(1);
  will-change: transform;
}

/* ==================== RESPONSIVE ==================== */
@media (max-width: 380px) {
  .titulo-script { font-size: 32px; }
  .hora { font-size: 22px; }
  .lugar { font-size: 16px; letter-spacing: 0.08em; }
}

@media (prefers-reduced-motion: reduce) {
  * { transition: none !important; animation: none !important; }
}

.lux-escena-final {
  position: relative;
  width: 100%;
  display: grid;
  place-items: center;
  margin-top: 8px;
  margin-bottom: -80px;
  overflow: visible;
}

.lux-flores {
  position: absolute;
  bottom: -2px;
  left: 50%;
  transform: translateX(-50%);
  width: min(760px, 110%);
  max-width: 110%;
  pointer-events: none;
  filter: drop-shadow(0 8px 18px rgba(0, 0, 0, 0.08));
  opacity: 0.98;
}
</style>